<template>
  <v-container class="ProfilInterface">
    <v-sheet
      min-height="300"
      rounded="lg"
      elevation="6"
    >
    <Toolbar
      :handle-delete="del"
      :handle-reset="resetForm"
      :handle-submit="onSendForm"
      >

        <template slot="left">
          <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50"  >
            <h1><v-icon large>mdi-account-box-multiple</v-icon>{{ item['name'] }}</h1>
          </v-toolbar-title>
        </template>
    </Toolbar>

    <ProfilInterfaceForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <Loading :visible="isLoading || deleteLoading" />
  </v-sheet>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ProfilInterfaceForm from '../../components/profilinterface/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';

const servicePrefix = 'ProfilInterface';

export default {
  name: 'ProfilInterfaceUpdate',
  servicePrefix,
  mixins: [UpdateMixin],
  components: {
    Loading,
    Toolbar,
    ProfilInterfaceForm
  },

  computed: {
    ...mapFields('profilinterface', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('profilinterface', ['find']),

  },

  methods: {
    ...mapActions('profilinterface', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    }),


  }
};
</script>
